<div class="attribute-editor-component" rvSpinner="custom-font-selector-editor-loader" [rvShowSpinner]="spinner">
  <basic-uploader [uploaderId]="'custom-font-uploader'"
    [uploadManager]="storageUploadManager"
    [validType]="fileType"
    [shown]="isUploading">
  </basic-uploader>
  <div class="attribute-editor-component">
    <div class="attribute-editor-row">
      <div class="form-group has-feedback" [ngClass]="{ 'has-error': validationResult && validationResult !== 'VALID', 'has-success': validationResult === 'VALID' && fontUrl !== '' }">
        <label for="custom-font-url">Font URL</label>
        <p>Enter the direct URL to a .otf, .ttf, .woff, or .woff2 font file hosted on your server or storage.</p>
        <input type="text" id="custom-font-url" class="form-control u_ellipsis" [(ngModel)]="fontUrl" placeholder="https://"
          (debounceEvent)="fontUrlChanged()" (ngModelChange)="clearValidationResult()">
        <!-- TODO: we can convert to a switch if/when we want to display different error messages per validation result -->
        <p class="help-block" [shown]="validationResult && validationResult !== 'VALID'">
          Invalid URL. Please enter a valid font file URL (.otf, .ttf, .woff, .woff2).
        </p>
        <button class="btn btn-primary btn-block mt-4" [disabled]="!fontUrl || validationResult !== 'VALID'" (click)="saveFontUrl()">
          Save URL
        </button>
      </div>
      <div class="or-separator">
        <span>or</span>
      </div>
      <div>
        <button id="upload-file-unsubscribed" class="btn btn-default btn-block" (click)="currentPlanService.showUnlockThisFeatureModal()" [hidden]="currentPlanService.isPlanActive()">
          Upload Font
        </button>
        <label tabindex="0" (keyup.enter)="activateUploader()" id="custom-font-uploader-label"
          class="btn btn-default btn-block aligner"
          for="custom-font-uploader"
          [attr.disabled]="isUploading ? true : null" [shown]="currentPlanService.isPlanActive()"
          >
          Upload Font
        </label>
      </div>
      <div>
        <button tabindex="0" id="te-font-select" class="btn btn-default btn-block mt-4" [disabled]="isUploading" (click)="selectFromStorage()">
          Select from Storage
        </button>
      </div>
    </div>
  </div>
</div>
